import { useStoreActions, useStoreState } from '@src/store/store';

export function useValidateById() {
  const validate = useStoreActions((actions) => actions.journeys.validateById);

  const request = useStoreState((state) => state.requests.entities['journeys.validateById']);

  return { validate, isLoading: Boolean(request) };
}
